class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  onClickHandler(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading');
    this.classList.add('disabled');

    const grid = document.getElementById('product-grid');
    const sectionId = grid?.dataset?.id;
    let url = this.dataset.url;
    if (url) {
      if (sectionId && !url.includes('section_id=')) {
        url += (url.includes('?') ? '&' : '?') + `section_id=${encodeURIComponent(sectionId)}`;
      }
      InfiniteScroll.renderSectionFromFetch(url, this);
    }
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    const grid = document.getElementById('product-grid');
    return [
      {
        section: grid ? grid.dataset.id : '',
      }
    ];
  }

  static renderSectionFromFetch(url, buttonEl) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const doc = new DOMParser().parseFromString(responseText, 'text/html');
        InfiniteScroll.renderProductGridContainer(doc);
        InfiniteScroll.renderPagination(doc, buttonEl);
      })
      .catch((e) => {
        console.error(e);
        if (buttonEl) {
          buttonEl.classList.remove('loading');
          buttonEl.classList.remove('disabled');
        }
      });
  }

  static renderPagination(doc, buttonEl) {
    const nextBtn = doc.querySelector('infinite-scroll');
    if (nextBtn && nextBtn.dataset.url) {
      if (buttonEl) {
        buttonEl.dataset.url = nextBtn.dataset.url;
        buttonEl.classList.remove('loading');
        buttonEl.classList.remove('disabled');
      }
    } else {
      const container = document.getElementById('ProductGridContainer')?.querySelector('.pagination-wrapper');
      if (container) {
        container.remove();
      } else if (buttonEl) {
        buttonEl.remove();
      }
    }
  }

  static renderProductGridContainer(doc) {
    const container = document.getElementById('product-grid');
    const products = doc.getElementById('product-grid');
    if (container && products) {
      container.insertAdjacentHTML('beforeend', products.innerHTML);
    }
  }
}
customElements.define('infinite-scroll', InfiniteScroll);
